cl<template>
      <div class="div_outer_box">
        <div class="deposit_demo_video_section" >
                <div class="custom_container">
                    <div class="withdraws_video_sec">
                        <div v-for="(video,videoKey,index) in ($route.name == 'wallet-deposit' ? walletConfig.deposit_video : walletConfig.withdrawal_video)" :key="index">
                            <template v-if="video">
                                <div class="withdraws-video-con">
                                    <div class="video_thm_title">
                                        <h2 v-if="type == 2 || type == 3">
                                            {{$route.name == 'wallet-deposit' ? $t('how-to-deposit', 'How To Deposit') : $t('how-to-withdraw', 'How To Withdraw') }} ({{ videoKey }})
                                        </h2>
                                    </div>
                                    <iframe width="100%" height="200" :src="video" :title="videoKey" frameborder="0" allowfullscreen="allowfullscreen" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"> </iframe>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
   </div>
</template>
<script>
export default {
    name: 'TutorialVideo',
    props:['type'],
    inject: ['walletConfig'],
     computed: {
        tutorialVideosData() {
            return this.walletConfig.videos?.filter(item => item?.type == this.type);
        },
    },
}
</script>